<template>
<div class="chapter">
<div class="inner_page">
<p class="No-Paragraph-Style-3" id="epi"> </p>
<p class="No-Paragraph-Style-3"> </p>
<p class="No-Paragraph-Style-3"> </p>
<p class="FMEP">I honor beginnings. Of all things, I honor beginnings. I believe that what was has always been, and what is has always been, and what will be has always been.</p>
<p class="HALF-SPACE"> </p>
<p class="FMEPC">—Louis Kahn</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?49467014